import { useSelector } from 'react-redux';
import { getDistanceUnitSelector } from 'store/Common/selectors';
import { S } from './PinCard.styles';
import { PinCardProps } from './PinCard.inteface';
import { FormattedMessage } from 'react-intl';
import { DeleteButton } from 'shared/Buttons/DeleteButton/DeleteButton';


export const PinCard: React.FC<PinCardProps> = ({
  pin,
  onPinRemoveClick
}) => {
  const actualDistanceUnit = useSelector(getDistanceUnitSelector);

  const handleDelete = () => {
      onPinRemoveClick(pin)
  };

  return (
    <S.Container>
      <S.RouteInfo>
        <S.Title>
          {(pin.distance != null) && (
            <S.LiBase>
              {(pin.distance / actualDistanceUnit.valueInMeters).toFixed(1)}{' '}
              <FormattedMessage id={actualDistanceUnit.name}/>
            </S.LiBase>
          )}
        </S.Title>
        <S.ShortInfo>{pin.trailName}</S.ShortInfo>
      </S.RouteInfo>
      <DeleteButton
        onClick={handleDelete}
      />
    </S.Container>
  );
};
